export default function accordion() {

    const accordions = document.querySelectorAll('.js-accordion');

    if(accordions.length > 0){
        accordions.forEach((accordion, index) => {
            const button = accordion.querySelector('.faq__accordion-title');
            const content = accordion.querySelector('.faq__accordion-text');

            if (!button || !content) return;

            const contentId = `faq-accordion-${index}`;
            const isOpen = accordion.classList.contains('active');

            content.id = contentId;
            button.setAttribute('aria-controls', contentId);
            button.setAttribute('aria-expanded', String(isOpen));
            content.style.maxHeight = isOpen ? `${content.scrollHeight}px` : '0px';

            accordion.addEventListener('click', () => {
                const willOpen = !accordion.classList.contains('active');

                accordion.classList.toggle('active', willOpen);
                button.setAttribute('aria-expanded', String(willOpen));
                content.style.maxHeight = willOpen ? `${content.scrollHeight}px` : '0px';
            });
        });

        window.addEventListener('resize', () => {
            accordions.forEach((accordion) => {
                if (!accordion.classList.contains('active')) return;

                const content = accordion.querySelector('.faq__accordion-text');
                if (content) content.style.maxHeight = `${content.scrollHeight}px`;
            });
        });
    }

}